module.exports = __webpack_public_path__ + "img/appliances.52234456.jpg";